<template>
  <div>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.hemograma"
          label="Hemograma"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.hto"
          label="HTO"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.gluc"
          label="Gluc."
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.uremia"
          label="Uremia"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.ionograma"
          label="Ionograma"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.hepatograma"
          label="Hepatograma"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.col"
          label="COL"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.ldl"
          label="LDL"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.hdl"
          label="HDL"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.tgc"
          label="TGC"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.orina"
          label="Orina"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.otro"
          label="Otro"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import evolucionJsonMixin from "../../../../mixins/evolucionJsonMixin";
export default {
  data() {
    return {
      values: {
        col: null,
        ldl: null,
        hdl: null,
        gluc: null,
        tgc: null,
        hemograma: null,
        hto: null,
        uremia: null,
        ionograma: null,
        hepatograma: null,
        orina: null,
        otro: null,
      },
    };
  },
  mixins: [evolucionJsonMixin],
  computed: {
    camposRequeridos() {
      return false;
    },
    defaultValues() {
      return {
        col: null,
        ldl: null,
        hdl: null,
        gluc: null,
        tgc: null,
        hemograma: null,
        hto: null,
        uremia: null,
        ionograma: null,
        hepatograma: null,
        orina: null,
        otro: null,
      };
    },
  },
  created() {
    if (!this.evolucionJson) {
      this.values = { ...this.defaultValues };
    }
  },
};
</script>
